/* MEATBROS · mb-global.js
   En-tête : méga menus desktop (survol, clic, clavier), menu mobile sur 3 niveaux (accessibilité),
   intégration à l'éditeur de thème. Vanilla, sans dépendance. Chargé en defer après meatbros.js.
   AR Digital 2026. */
(function () {
  'use strict';

  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var mqDesktop = window.matchMedia('(min-width: 1201px)');
  var mqSurvol = window.matchMedia('(hover: hover) and (pointer: fine)');
  var DELAI_OUVERTURE = 80;   // premier panneau
  var DELAI_BASCULE = 120;    // passage d'une entrée à l'autre (évite les bascules en diagonale)
  var DELAI_FERMETURE = 220;

  function surChangement(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  /* ---------- Méga menus desktop ---------- */
  var courant = null;      // li[data-mega-item] ouvert
  var mode = null;         // 'survol' ou 'clic'
  var minuterieOuverture = null;
  var minuterieFermeture = null;

  function bouton(item) { return item.querySelector('[data-mega-toggle]'); }

  function ouvrir(item, via) {
    clearTimeout(minuterieOuverture);
    clearTimeout(minuterieFermeture);
    if (courant && courant !== item) fermer(courant);
    item.classList.add('ouvert');
    var b = bouton(item);
    if (b) b.setAttribute('aria-expanded', 'true');
    courant = item;
    mode = via;
  }

  function fermer(item, rendreFocus) {
    if (!item) return;
    clearTimeout(minuterieFermeture);
    item.classList.remove('ouvert');
    var b = bouton(item);
    if (b) {
      b.setAttribute('aria-expanded', 'false');
      if (rendreFocus) b.focus();
    }
    if (courant === item) { courant = null; mode = null; }
  }

  function initMega(scope) {
    $$('[data-mega-item]', scope).forEach(function (item) {
      if (item.getAttribute('data-mega-pret')) return;
      item.setAttribute('data-mega-pret', '1');

      item.addEventListener('mouseenter', function () {
        if (!mqSurvol.matches || !mqDesktop.matches) return;
        clearTimeout(minuterieFermeture);
        if (courant === item) return;
        clearTimeout(minuterieOuverture);
        minuterieOuverture = setTimeout(function () { ouvrir(item, 'survol'); }, courant ? DELAI_BASCULE : DELAI_OUVERTURE);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(minuterieOuverture);
        if (courant !== item || mode !== 'survol') return;
        // Navigation clavier en cours dans le panneau : on ne le ferme pas sous le focus.
        var actif = document.activeElement;
        try { if (actif && item.contains(actif) && actif.matches(':focus-visible')) return; } catch (err) {}
        minuterieFermeture = setTimeout(function () { fermer(item); }, DELAI_FERMETURE);
      });

      var b = bouton(item);
      if (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (courant === item) {
            // Ouvert au survol puis cliqué : on le garde ouvert (évite l'effet « s'ouvre puis se ferme »).
            if (mode === 'survol') { mode = 'clic'; clearTimeout(minuterieFermeture); return; }
            fermer(item);
          } else {
            ouvrir(item, 'clic');
          }
        });
      }

      // Le focus clavier quitte l'entrée (Tab vers l'entrée suivante) : on ferme.
      item.addEventListener('focusout', function (e) {
        var vers = e.relatedTarget;
        if (courant !== item || !vers || item.contains(vers)) return;
        fermer(item);
      });

      // Un lien du panneau (ancre sur la même page comprise) referme le panneau.
      item.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.mega a')) fermer(item);
      });
    });
  }

  // Clic en dehors : fermeture.
  document.addEventListener('click', function (e) {
    if (courant && !courant.contains(e.target)) fermer(courant);
  });

  // Échap : fermeture du panneau (retour du focus sur sa flèche) et du menu mobile.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (courant) fermer(courant, courant.contains(document.activeElement));
    if (menuMobileOuvert()) fermerMenuMobile();
    var r = document.getElementById('Recherche');
    if (r && r.classList.contains('ouvert')) { r.classList.remove('ouvert'); r.setAttribute('aria-hidden', 'true'); }
  });

  /* ---------- Menu mobile ---------- */
  var focusAvantMenu = null;

  function menuMobile() { return document.getElementById('MenuMobile'); }
  function menuMobileOuvert() { var m = menuMobile(); return !!(m && m.classList.contains('ouvert')); }

  // Mêmes effets que meatbros.js, qui reste en place : ces fonctions ne servent que si ses écouteurs
  // ont disparu (section rechargée dans l'éditeur de thème).
  function ouvrirMenuMobile() {
    var m = menuMobile(); if (!m) return;
    m.classList.add('ouvert'); m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-ouvert'); document.body.style.overflow = 'hidden';
  }
  function fermerMenuMobile() {
    var m = menuMobile(); if (!m) return;
    m.classList.remove('ouvert'); m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-ouvert'); document.body.style.overflow = '';
  }

  function focusables(m) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', m)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  // Suit l'ouverture et la fermeture (quel que soit le script qui les déclenche) pour gérer le focus.
  function observerMenuMobile() {
    var m = menuMobile();
    if (!m || m.getAttribute('data-mb-observe')) return;
    m.setAttribute('data-mb-observe', '1');
    var etat = m.classList.contains('ouvert');
    new MutationObserver(function () {
      var ouvert = m.classList.contains('ouvert');
      if (ouvert === etat) return;
      etat = ouvert;
      $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', ouvert ? 'true' : 'false'); });
      if (ouvert) {
        focusAvantMenu = document.activeElement;
        var fermerBtn = m.querySelector('[data-menu-close]');
        if (fermerBtn) setTimeout(function () { fermerBtn.focus(); }, 60);
      } else if (focusAvantMenu && document.body.contains(focusAvantMenu)) {
        focusAvantMenu.focus();
        focusAvantMenu = null;
      }
    }).observe(m, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var m = menuMobile();

    // Secours : ouverture et fermeture si meatbros.js n'a pas (ou plus) d'écouteur sur ces boutons.
    if (m && e.target.closest('[data-menu-open]') && !m.classList.contains('ouvert')) ouvrirMenuMobile();
    if (m && e.target.closest('[data-menu-close]') && m.classList.contains('ouvert')) fermerMenuMobile();
    var r = document.getElementById('Recherche');
    if (r && e.target.closest('[data-search-open]') && !r.classList.contains('ouvert')) {
      e.preventDefault();
      r.classList.add('ouvert'); r.setAttribute('aria-hidden', 'false');
      var champ = r.querySelector('input[type="search"]');
      if (champ) setTimeout(function () { champ.focus(); }, 50);
    }
    if (r && r.classList.contains('ouvert') && (e.target.closest('[data-search-close]') || e.target === r)) {
      r.classList.remove('ouvert'); r.setAttribute('aria-hidden', 'true');
    }

    // Dépliage des entrées du menu mobile.
    var bascule = e.target.closest('[data-mm-toggle]');
    if (bascule) {
      var panneau = document.getElementById(bascule.getAttribute('aria-controls'));
      if (!panneau) return;
      var deplie = bascule.getAttribute('aria-expanded') === 'true';
      bascule.setAttribute('aria-expanded', deplie ? 'false' : 'true');
      panneau.hidden = deplie;
      return;
    }

    // Lien vers une ancre de la page en cours : on referme le menu pour laisser voir la cible.
    var lien = e.target.closest('#MenuMobile a[href]');
    if (lien && lien.hash && lien.pathname === window.location.pathname) fermerMenuMobile();
  });

  // Piège à focus dans le menu mobile ouvert.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !menuMobileOuvert()) return;
    var liste = focusables(menuMobile());
    if (!liste.length) return;
    var premier = liste[0], dernier = liste[liste.length - 1];
    if (e.shiftKey && (document.activeElement === premier || !menuMobile().contains(document.activeElement))) {
      e.preventDefault(); dernier.focus();
    } else if (!e.shiftKey && (document.activeElement === dernier || !menuMobile().contains(document.activeElement))) {
      e.preventDefault(); premier.focus();
    }
  });

  /* ---------- Changement de largeur ---------- */
  surChangement(mqDesktop, function () {
    if (mqDesktop.matches) { if (menuMobileOuvert()) fermerMenuMobile(); }
    else if (courant) fermer(courant);
  });

  /* ---------- Éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    courant = null; mode = null;
    initMega(e.target);
    observerMenuMobile();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('[data-mega-item]');
    if (item && mqDesktop.matches) ouvrir(item, 'clic');
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest && e.target.closest('[data-mega-item]');
    if (item) fermer(item);
  });

  initMega(document);
  observerMenuMobile();
})();
